import React from 'react';
import { Container, Typography } from '@mui/material';

const About = () => {
  return (
    <Container maxWidth={'sm'} sx={{ marginTop: '16px', minHeight: '60vh' }}>
      <Typography fontWeight={'bold'} variant="h1" gutterBottom>
        Welcome to ILH Oy
      </Typography>
      <Typography textAlign={'justify'}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis
        architecto, accusantium rerum mollitia ex ab at beatae reiciendis. Quae,
        facilis sint ea aperiam non nam nisi dolores ratione repellat. Quos.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis
        architecto, accusantium rerum mollitia ex ab at beatae reiciendis. Quae,
        facilis sint ea aperiam non nam nisi dolores ratione repellat. Quos.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis
        architecto, accusantium rerum mollitia ex ab at beatae reiciendis. Quae,
        facilis sint ea aperiam non nam nisi dolores ratione repellat. Quos.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis
        architecto, accusantium rerum mollitia ex ab at beatae reiciendis. Quae,
        facilis sint ea aperiam non nam nisi dolores ratione repellat. Quos.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis
        architecto, accusantium rerum mollitia ex ab at beatae reiciendis. Quae,
        facilis sint ea aperiam non nam nisi dolores ratione repellat. Quos.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis
        architecto, accusantium rerum mollitia ex ab at beatae reiciendis. Quae,
        facilis sint ea aperiam non nam nisi dolores ratione repellat. Quos.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Nobis architecto,
        accusantium rerum mollitia ex ab at beatae reiciendis. Quae, facilis
        sint ea aperiam non nam nisi dolores ratione repellat. Quos. Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Nobis architecto,
        accusantium rerum mollitia ex ab at beatae reiciendis. Quae, facilis
        sint ea aperiam non nam nisi dolores ratione repellat. Quos. Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Nobis architecto,
        accusantium rerum mollitia ex ab at beatae reiciendis. Quae, facilis
        sint ea aperiam non nam nisi dolores ratione repellat. Quos. Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Nobis architecto,
        accusantium rerum mollitia ex ab at beatae reiciendis. Quae, facilis
        sint ea aperiam non nam nisi dolores ratione repellat. Quos. Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Nobis architecto,
        accusantium rerum mollitia ex ab at beatae reiciendis. Quae, facilis
        sint ea aperiam non nam nisi dolores ratione repellat. Quos. Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Nobis architecto,
        accusantium rerum mollitia ex ab at beatae reiciendis. Quae, facilis
        sint ea aperiam non nam nisi dolores ratione repellat. Quos. Lorem ipsum
        dolor sit amet consectetur adipisicing elit.
      </Typography>
    </Container>
  );
};

export default About;
